module.exports = __webpack_public_path__ + "static/media/tupp-min.ad29f7b9.png";